import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const PURCHASES = [{
  name: 'María',
  country: 'México'
}, {
  name: 'Carlos',
  country: 'Argentina'
}, {
  name: 'Ana',
  country: 'España'
}, {
  name: 'Luis',
  country: 'Colombia'
}, {
  name: 'Sofia',
  country: 'Chile'
}, {
  name: 'Valentina',
  country: 'Perú'
}, {
  name: 'Diego',
  country: 'Uruguay'
}];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const showNotification = () => {
      // Pick random purchase
      const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      setCurrentPurchase(randomPurchase);
      setVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setVisible(false);
      }, 5000);
      // Schedule next show (between 10-15 seconds after hiding)
      const nextDelay = Math.random() * 5000 + 10000 + 5000;
      setTimeout(showNotification, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 right-4 md:bottom-8 md:right-8 bg-white rounded-lg shadow-2xl p-4 max-w-xs z-40 border-l-4 border-green-500 flex items-center gap-3 animate-in slide-in-from-bottom-10 fade-in duration-500" data-id="element-201">
      <div className="bg-green-100 p-2 rounded-full" data-id="element-202">
        <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-203" />
      </div>
      <div data-id="element-204">
        <p className="text-sm font-bold text-gray-900" data-id="element-205">
          {currentPurchase.name} de {currentPurchase.country}
        </p>
        <p className="text-xs text-gray-600" data-id="element-206">
          acaba de comprar{' '}
          <span className="font-semibold text-blue-600" data-id="element-207">Pack 100 Citas</span>
        </p>
        <p className="text-[10px] text-gray-400 mt-1" data-id="element-208">Hace unos segundos</p>
      </div>
    </div>;
}